<template>
	<section id="ecosystem" class="ecosystem">
		<!-- <iframe
			class="ecosystem__img"
			src="https://visitedplaces.com/embed/?map=world&projection=geoOrthographic&theme=dark-yellow&water=1&graticule=0&names=1&duration=2000&placeduration=100&slider=0&autoplay=0&autozoom=all&autostep=0&home=UZ&places=%D0%97~KZ_PK_BD~2.3_80.5_40.6_-67.2_-43.6"></iframe> -->
		<div class="ecosystem__map">
			<img
				class="ecosystem__img"
				src="/images/sections/ecosystem/map.jpg"
				alt="map"
				fetchpriority="high"
				loading="eager"
				decoding="async" />
			<BlocksMapSvg
				v-model:kz-hovered="kzHovered"
				v-model:uz-hovered="uzHovered"
				v-model:pk-hovered="pkHovered"
				v-model:bg-hovered="bgHovered"
				class="ecosystem__svg" />

			<!-- <div class="ecosystem__tooltip"> -->
			<div class="ecosystem__tooltip kz" :class="{ hovered: kzHovered }">
				<img
					src="/images/sections/ecosystem/kz/flag.webp"
					width="100"
					alt="Kazakhstan flag"
					loading="lazy"
					decoding="async" />
				<img
					v-for="i in 3"
					:key="i"
					class="ecosystem__tooltip-img"
					:src="`/images/sections/ecosystem/kz/${i}.webp`"
					:alt="`Kazakhstan ecosystem logo ${i}`"
					width="50"
					loading="lazy"
					decoding="async" />
			</div>
			<div class="ecosystem__tooltip uz" :class="{ hovered: uzHovered }">
				<img
					src="/images/sections/ecosystem/uz/flag.webp"
					width="100"
					alt="Uzbekistan flag"
					loading="lazy"
					decoding="async" />
				<img
					v-for="i in 3"
					:key="i"
					class="ecosystem__tooltip-img"
					:src="`/images/sections/ecosystem/uz/${i}.webp`"
					:alt="`Uzbekistan ecosystem logo ${i}`"
					width="50"
					loading="lazy"
					decoding="async" />
			</div>
			<div class="ecosystem__tooltip pk" :class="{ hovered: pkHovered }">
				<img
					src="/images/sections/ecosystem/pk/flag.webp"
					width="100"
					alt="Pakistan flag"
					loading="lazy"
					decoding="async" />
				<img
					v-for="i in 3"
					:key="i"
					class="ecosystem__tooltip-img"
					:src="`/images/sections/ecosystem/pk/${i}.webp`"
					:alt="`Pakistan ecosystem logo ${i}`"
					width="50"
					loading="lazy"
					decoding="async" />
			</div>
			<div class="ecosystem__tooltip bg" :class="{ hovered: bgHovered }">
				<img
					src="/images/sections/ecosystem/bg/flag.webp"
					width="100"
					alt="Bangladesh flag"
					loading="lazy"
					decoding="async" />
				<img
					v-for="i in 1"
					:key="i"
					class="ecosystem__tooltip-img"
					:src="`/images/sections/ecosystem/bg/${i}.webp`"
					:alt="`Bangladesh ecosystem logo ${i}`"
					width="50"
					loading="lazy"
					decoding="async" />
			</div>
			<!-- </div> -->
			<Icon class="ecosystem__tooltip-pointer" name="tabler:hand-finger" size="56" />
		</div>

		<div class="ecosystem__container container">
			<div class="ecosystem__content">
				<div class="ecosystem__header">
					<h2 class="ecosystem__title heading h2">
						{{ $t('pages.main.sections.ecosystem.title') }}
					</h2>
					<h3 :class="['ecosystem__subtitle', 'heading', isMobile ? 'h6' : 'h4']">
						{{ $t('pages.main.sections.ecosystem.subtitle') }}
					</h3>
				</div>
				<div class="ecosystem__footer">
					<p class="ecosystem__text">
						{{ $t('pages.main.sections.ecosystem.small') }}
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	const { $gsap: gsap } = useNuxtApp()
	const kzHovered = ref(false)
	const uzHovered = ref(false)
	const pkHovered = ref(false)
	const bgHovered = ref(false)

	function ecosystemAnimation() {
		if (!isMobile.value) {
			gsap
				.timeline({
					scrollTrigger: {
						trigger: '.ecosystem',
						start: 'top bottom',
						end: 'bottom top',
						// end: 'bottom+=200',
						// start: 'top top',
						// end: 'bottom top',
						// end: 'bottom top',
						scrub: true,
						onEnter: () => document.querySelector('.ecosystem')?.classList.add('entered'),
					},
				})
				.fromTo(
					'.ecosystem__map',
					{
						yPercent: -20,
						// scale: 1.2,
						ease: 'none',
					},
					{
						yPercent: 20,
						// scale: 1.2,
						ease: 'none',
					}
				)
		}
	}

	const isMobile = computed(() => {
		return import.meta.client ? window.innerWidth < 768 : false
	})

	// function ecosystemAnimation() {
	// 	// gsap
	// 	// 	.timeline({
	// 	// 		scrollTrigger: {
	// 	// 			trigger: '.intro',
	// 	// 			start: 'top top',
	// 	// 			// end: 'bottom+=200',
	// 	// 			// start: 'top top',
	// 	// 			// end: 'bottom top',
	// 	// 			// end: 'bottom top',
	// 	// 			scrub: true,
	// 	// 			pin: true,
	// 	// 			pinSpacing: false,
	// 	// 		},
	// 	// 	})
	// 	// 	.to('.intro__bg', {
	// 	// 		yPercent: -20,
	// 	//         // scale: 1.2,
	// 	// 		ease: 'none',
	// 	// 	})
	// 	gsap
	// 		.timeline({
	// 			scrollTrigger: {
	// 				trigger: '.ecosystem',
	// 				start: 'top bottom',
	//                 end: 'bottom top',
	// 				scrub: true,
	//                 markers: true,
	// 				// 			pin: true,
	// 				// 			pinSpacing: false,
	// 			},
	// 		})
	// 		.fromTo(
	// 			'.ecosystem__img',
	// 			{
	// 				yPercent: -40,
	// 				ease: 'none',
	// 			},
	// 			{
	// 				yPercent: 40,
	// 			}
	// 		)
	// }

	onMounted(() => {
		setTimeout(() => {
			ecosystemAnimation()
		}, 200)
	})
</script>

<style scoped lang="scss">
	.ecosystem {
		position: relative;
		top: -100px;
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: center;

		// border-radius: 50px 50px 0 0;
		max-height: 100svh;
		overflow: clip;

		// scroll-margin-top: 80px;
		background-color: #5c5c5c;

		// @media (max-width: 767.98px) {
		// 	border-radius: 20px 20px 0 0;
		// }
		&::before {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			width: 100%;
			height: 20%;
			pointer-events: none;
			content: '';
			background: linear-gradient(to bottom, #5c5c5c 0%, rgb(42 42 42 / 0%) 100%);
			transition: 0.4s opacity;

			@media (width <= 767.98px) {
				min-height: 20%;
				background: linear-gradient(to bottom, #5c5c5c 40%, rgb(42 42 42 / 0%) 100%);
			}

			@media (width <= 575.98px) {
				min-height: 20%;
				background: linear-gradient(to bottom, #5c5c5c 60%, rgb(42 42 42 / 0%) 100%);
			}

			@media (width <= 410px) {
				min-height: 30%;
				background: linear-gradient(to bottom, #5c5c5c 50%, rgb(42 42 42 / 0%) 100%);
			}
		}
		&::after {
			position: absolute;
			bottom: 0;
			left: 0;
			z-index: 1;
			width: 100%;
			height: 10%;
			pointer-events: none;
			content: '';
			background: linear-gradient(to top, rgb(42 42 42) 0%, rgb(42 42 42 / 0%) 100%);
			transition: 0.4s opacity;

			@media (width <= 767.98px) {
				min-height: 25%;
				background: linear-gradient(to top, rgb(42 42 42) 40%, rgb(42 42 42 / 0%) 100%);
			}

			@media (width <= 410px) {
				min-height: 25%;
				background: linear-gradient(to top, rgb(42 42 42) 40%, rgb(42 42 42 / 0%) 100%);
			}
		}

		@media (width <= 767.98px) {
			min-height: 90svh;
			max-height: unset;
		}

		@media (width <= 575.98px) {
			min-height: 80svh;
		}

		// &.entered {
		// 	.ecosystem__container {
		// 		opacity: 1;
		// 	}
		// 	.ecosystem__img {
		// 		transition: 0.5s 3.5s opacity;
		// 		// opacity: 0.5;
		// 	}
		// }
		&__map {
			position: relative;

			// width: max-content;
			margin: 0 auto;
			&:has(.ecosystem__tooltip.hovered) .ecosystem__tooltip-pointer {
				display: none;
			}
		}
		&__img {
			// width: 100%;
			// height: 100%;
			// position: absolute;
			top: 0;
			left: 0;

			// transform: scale(1.2);
			// object-fit: cover;
			// object-position: right;
			// z-index: 1;
			// opacity: 0.5;
			// transform: scale(1.2);
			pointer-events: none;
			object-fit: contain;

			@media (width <= 767.98px) {
				object-position: 30.5px;

				// transform: scale(2);
				// object-fit: cover;
				// height: 100%;
				// width: 100%;
				transform: scale(2.3);
			}

			@media (width <= 575.98px) {
				object-position: 22.5px;
				transform: scale(2.2);
			}
		}
		&__svg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;

			@media (width <= 767.98px) {
				left: 70px;

				// transform: scale(2);
				transform: scale(2.3);
			}

			@media (width <= 575.98px) {
				left: 50px;
				transform: scale(2.2);
			}

			// transform: scale(1.2);
			// object-fit: cover;
			// object-position: right;
			// z-index: 1;
			// opacity: 0.5;
			// transform: scale(1.2);
		}
		&__tooltip {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
			display: flex;
			gap: 8px;
			align-items: center;
			max-width: 300px;

			// opacity: 0;
			// transition: 0.5s 3.5s opacity;
			pointer-events: none;
			opacity: 0;
			transition: 0.4s opacity;

			@media (width <= 767.98px) {
				transform: scale(0.7);
			}

			@media (width <= 575.98px) {
				transform: scale(0.5);
			}
			&.hovered {
				opacity: 1;

				@for $i from 1 through 5 {
					.ecosystem__tooltip-img:nth-child(#{$i}) {
						opacity: 1;
						transform: translateX(0);
						transition:
							0.4s $i * 0.1s opacity,
							0.4s $i * 0.1s transform;
					}
				}
			}
			&-pointer {
				position: absolute;
				top: 50%;
				left: 50%;
				z-index: 0;
				color: var(--white);
				pointer-events: none;
				transform: translate(-50%, -50%);
				animation: pointerAnimation 2s infinite;

				@media (width <= 767.98px) {
					scale: 0.8;
				}
			}

			@keyframes pointerAnimation {
				0% {
					opacity: 0;
					transform: translate(-50%, -50%) translateX(20px) translateY(20px);
				}
				100% {
					opacity: 0.6;
					transform: translate(-50%, -50%);
				}
			}
			&-img {
				opacity: 0;
				transform: translateX(-20px);
			}
			&.kz {
				top: 30%;
				left: 30%;

				@media (width <= 767.98px) {
					top: 10%;
					left: 20%;
				}

				@media (width <= 575.98px) {
					top: 0%;
					left: 20%;
				}
			}
			&.uz {
				top: 45%;
				left: 30%;

				@media (width <= 767.98px) {
					top: 35%;
					left: 10%;
				}

				@media (width <= 575.98px) {
					top: 30%;
					left: 10%;
				}
			}
			&.pk {
				top: 70%;
				left: 35%;

				@media (width <= 767.98px) {
					top: 90%;
					left: 25%;
				}

				@media (width <= 575.98px) {
					top: 80%;
					left: 28%;
				}
			}
			&.bg {
				top: 70%;
				left: 60%;

				@media (width <= 767.98px) {
					top: 90%;
					left: 70%;
				}

				@media (width <= 575.98px) {
					top: 100%;
					left: 70%;
				}
			}
		}
		&__container {
			position: absolute;
			top: 0;
			left: 50%;
			z-index: 2;
			width: 100%;
			height: 100%;

			// opacity: 0;
			// transition: 0.5s 3.5s opacity;
			pointer-events: none;
			transform: translateX(-50%);

			// @media (max-width: 767.98px) {
			// 	padding: 0 32px;
			// }
		}
		&__content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			// min-height: calc(100svh - 64px);
			height: 100%;
			padding: 32px 0;
			color: var(--white);

			@media (width <= 767.98px) {
				padding: 32px 0 16px;
			}
		}
		&__title {
			text-transform: uppercase;
		}
		&__text {
			font-family: Montserrat, sans-serif;
			font-size: clamp(0.875rem, 2vw, 1rem);
			span {
				font-weight: bold;
			}
		}
	}
</style>
